import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-muted-foreground" }

import { Card, CardContent } from '@/components/ui/card';
    import NoCompany from '@/components/icons/NoCompany.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'NoCompanyPlaceholderCard',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "m-1.5 min-h-0 flex-1" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardContent), { class: "flex h-full flex-col items-center justify-center" }, {
        default: _withCtx(() => [
          _createVNode(NoCompany, { className: "text-muted-foreground size-26" }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('datatables.no_company')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})